import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfFormatTypeRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-listdefinition-formattype";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
